import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-primary-container',
  templateUrl: './primary-container.component.html',
  styleUrls: ['./primary-container.component.scss']
})
export class PrimaryContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
